module.exports = __webpack_public_path__ + "assets/a6199eef2063d24486a379fa37b2181a.mp3";